import { Box, Heading, SimpleGrid, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CardBox from '../../components/shared/CardBox';
import { useColorModeValue } from '../../components/ui/color-mode';
import { darkMode, lightMode } from '../../theme/config';
import DailyComplaintRegistrations from './DailyComplaintRegistrations.jsx';
import DailyProductRegistrations from './DailyProductRegistrations.jsx';
import styles from './dashboard.module.css';
import { insightsPath } from '../../utils/constants/insightsPath.js';
import { loadInsightsRequest } from '../../store/insightsSlice.js';
import SelectBox from '../../components/shared/fields/SelectBox.jsx';
import { useForm } from 'react-hook-form';
import { dateRangeOptions } from './dashboardConstants.js';


const Dashboard = () => {
  const textColor = useColorModeValue(lightMode.textColor, darkMode.textColor);
  const [startTime] = useState(Date.now() - 30 * 24 * 60 * 60 * 1000); // 30 days ago
  const [endTime] = useState(Date.now());
  const dashboardData = useSelector((state) => state.insights[insightsPath.DASHBOARD] || {
    cards: [],
    graphs: [],
    loading: false,
    error: null,
  });
  const dispatch = useDispatch();

  const { control } = useForm();

  useEffect(() => {
    dispatch(loadInsightsRequest({
      key: insightsPath.DASHBOARD,
      startTime,
      endTime,
    }));
  }, [startTime, endTime]);

  return (
    <Box className={styles.container}>
      {/* Header Section */}
      <Box className={styles.header}>
        <Box width={"70%"}>
          <Heading size="3xl" color={textColor} fontWeight="bold">Home</Heading>
          <Text>Welcome Back. Here's an overview of your CRM metrics</Text>
        </Box>
        <Box width={"20%"}>
          <SelectBox
            label="Date Range"
            name="dateRange"
            control={control}
            items={dateRangeOptions}
            placeholder="Last 30 Days"
            disabled={true}
          />
        </Box>
      </Box>

      {/* Cards Section */}


      {dashboardData.cards && dashboardData.cards.length > 0 && (
        <SimpleGrid
          columns={{ base: 1, sm: 2, md: 3, lg: 4 }}
          spacing={{ base: 4, md: 6 }}
        >
          {dashboardData.cards.map((stat, index) => (
            <CardBox source="DASHBOARD" key={index} heading={stat.title} body={stat.value.toLocaleString()} footer={stat.subtitle} icon={stat.icon} />
          ))}
        </SimpleGrid>
      )}

      {/* Table Section */}
      <SimpleGrid columns={{ base: 1, md: 2, lg: 2 }} gap={5} >
        <DailyProductRegistrations productRegistrations={dashboardData.graphs.DailyProductRegistrations} />
        <DailyComplaintRegistrations complaintRegistrations={dashboardData.graphs.DailyComplaints} />
      </SimpleGrid>
    </Box>
  );
};

export default Dashboard;